export default __webpack_public_path__ + "static/media/faq-img.d1bdbb5a.png";